import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ProductList from 'components/product/product-list'
import ProductListSlider from 'components/product/product-list-slider'

const RenderProductList = ({ isPhone, productList, windowWidth }) => {
  if (!isPhone || windowWidth >= 768) {
    return (
      <ProductList
        displayDescription
        displayPrice
        displaySwatches
        displayBadges
        displayManufacturerName
        displayWishlistIcon
        displayHoverInteractions
        list={productList}
        refId=""
        refType="ttb_landing_page"
      />
    )
  }

  return (
    <ProductListSlider
      isPhone={isPhone}
      list={productList}
      displayPremiumTags
      displayDescription
      displayWishlistIcon
      displayBullets={false}
      refId=""
      refType="ttb_landing_page"
    />
  )
}

RenderProductList.defaultProps = {
  windowWidth: 768,
}

RenderProductList.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  productList: PropTypes.shape({}).isRequired,
  windowWidth: PropTypes.number,
}

export default connect((state) => ({
  isPhone: state.device.isPhone,
}))(RenderProductList)
